import enAuth from './locales/en/auth.json'
import enCards from './locales/en/cards.json'
import enCommon from './locales/en/common.json'
import enErrors from './locales/en/errors.json'
import enEvents from './locales/en/events.json'
import enFacilities from './locales/en/facilities.json'
import enFooter from './locales/en/footer.json'
import enHubs from './locales/en/hubs.json'
import enNavigation from './locales/en/navigation.json'
import enPreview from './locales/en/preview.json'
import enProfile from './locales/en/profile.json'
import enRegistration from './locales/en/registration.json'
import enValidation from './locales/en/validation.json'
import frAuth from './locales/fr/auth.json'
import frCards from './locales/fr/cards.json'
import frCommon from './locales/fr/common.json'
import frErrors from './locales/fr/errors.json'
import frEvents from './locales/fr/events.json'
import frFacilities from './locales/fr/facilities.json'
import frFooter from './locales/fr/footer.json'
import frHubs from './locales/fr/hubs.json'
import frNavigation from './locales/fr/navigation.json'
import frPreview from './locales/fr/preview.json'
import frProfile from './locales/fr/profile.json'
import frRegistration from './locales/fr/registration.json'
import frValidation from './locales/fr/validation.json'

export const defaultNS = 'common' as const

export const namespaces = [
  'common',
  'navigation',
  'footer',
  'errors',
  'auth',
  'profile',
  'events',
  'registration',
  'cards',
  'hubs',
  'facilities',
  'preview',
  'validation',
] as const

export const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    footer: enFooter,
    errors: enErrors,
    auth: enAuth,
    profile: enProfile,
    events: enEvents,
    registration: enRegistration,
    cards: enCards,
    hubs: enHubs,
    facilities: enFacilities,
    preview: enPreview,
    validation: enValidation,
  },
  fr: {
    common: frCommon,
    navigation: frNavigation,
    footer: frFooter,
    errors: frErrors,
    auth: frAuth,
    profile: frProfile,
    events: frEvents,
    registration: frRegistration,
    cards: frCards,
    hubs: frHubs,
    facilities: frFacilities,
    preview: frPreview,
    validation: frValidation,
  },
} as const
